import { useScrollProgress } from "../../hooks/useScrollProgress";

const ScrollIndicator = () => {
  const progress = useScrollProgress();

  return (
    <div className="scroll-indicator">
      <div className="scroll-track">
        <div className="scroll-thumb" style={{ height: `${progress}%` }} />
      </div>

      <span className="scroll-pct">{String(progress).padStart(2, "0")}%</span>
    </div>
  );
};

export default ScrollIndicator;
